// 3D Model constants for SOIC/SOP packages
export const soicPinMarkerSize = 0.0003; // Similar to SSOP
export const soicPinMarkerOffset = (packageSizeX, packageSizeY) => (Math.log10(10 + Math.min(packageSizeX, packageSizeY) * 5000) - 1) / 500;
export const soicPinMarkerOffsetZ = 0.000001;
export const soicPinMarkerSegments = 32;
//# sourceMappingURL=soicConstants.js.map